import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _orderBy from "lodash/orderBy";
import PreLoader from "@wevo/react-components/lib/PreLoader";
import ExpectationsGraph from "./ExpectationsGraph";
import { statusPalette } from "../../helpers/constants/colorPalettes";
import styles from "../../styles/components/Expectations.css";
import { denormalize } from "normalizr";
import { pageResultsSchema } from "../../schemas";
import ExpectationsQuotes from "./ExpectationsQuotes";
import ExpectationsQuoteSelect from "./ExpectationsQuotesSelect";
import {
    isLoading,
    isLoaded,
    shouldLoadOnMount
} from "../../modules/asyncHttpAction";

export const OUTCOMES = [
    {
        key: "unmet",
        label: "Not Met",
        value: "numUnmet",
        color: statusPalette.bad
    },
    {
        key: "somewhat",
        label: "Somewhat Met",
        value: "numSomewhat",
        color: statusPalette.ok
    },
    {
        key: "met",
        label: "Fully Met",
        value: "numMet",
        color: statusPalette.good
    }
];

export function NoDataMessage() {
    return (
        <p className={styles.noDataMessage}>
            No expectation data found for this page
        </p>
    );
}

export function ExpectationsContent({ expectations, selectedExpectation }) {
    return (
        <div className={styles.chart}>
            <ExpectationsGraph expectations={expectations} />
            <div>
                <ExpectationsQuoteSelect
                    expectations={expectations}
                    selectedExpectationId={selectedExpectation.id}
                />
                <ExpectationsQuotes expectation={selectedExpectation} />
            </div>
        </div>
    );
}

export class Expectations extends React.PureComponent {
    static propTypes = {
        pageId: PropTypes.number.isRequired,
        expectations: PropTypes.arrayOf(
            PropTypes.shape({
                theme: PropTypes.string.isRequired,
                numMet: PropTypes.number.isRequired,
                numSomewhat: PropTypes.number.isRequired,
                numUnmet: PropTypes.number.isRequired,
                totalMentions: PropTypes.number.isRequired
            })
        )
    };

    componentWillMount() {
        if (
            !this.props.expectations ||
            shouldLoadOnMount(this.props.pageResultRequest)
        ) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            !this.props.expectations &&
            prevProps.pageId !== this.props.pageId
        ) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    render() {
        const { expectations, pageResultRequest } = this.props;
        return (
            <div className={styles.container}>
                <header className={styles.chapterHeader}>
                    <h2 className={styles.chapterTitle}>
                        Audience Expectations
                    </h2>
                    <p className={styles.chapterSubtitle}>
                        Expectations give a look into the mindset that visitors
                        bring to the page. Before a visitor comes to the page,
                        we ask what their hopes and concerns are when
                        considering this type of product. After they have viewed
                        and scored the page, we ask how well their initial
                        expectations were met or not met.
                    </p>
                </header>
                <div className={styles.body}>
                    {isLoading(pageResultRequest) && <PreLoader id="loading" />}
                    {isLoaded(pageResultRequest) &&
                        expectations &&
                        expectations.length === 0 && (
                            <NoDataMessage id="no-data" />
                        )}
                    {isLoaded(pageResultRequest) &&
                        expectations &&
                        expectations.length > 0 && (
                            <ExpectationsContent
                                id="expectations-content"
                                {...this.props}
                            />
                        )}
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state, props) {
    const { pageId } = props;
    const { pageResultRequest } = state.results;

    const pageResults =
        denormalize(pageId, pageResultsSchema, state.api) || null;
    const expectations = pageResults
        ? _orderBy(pageResults.expectations, ["totalMentions"], ["desc"])
        : null;

    const selectedExpectation =
        expectations &&
        (expectations.find(
            ({ id }) => id === state.results.selectedExpectationId
        ) ||
            expectations[0]);

    return {
        expectations,
        selectedExpectation,
        pageResultRequest
    };
}

export default connect(
    mapStateToProps,
    null
)(Expectations);



// WEBPACK FOOTER //
// ./src/components/Results/Expectations.js